import { Spinner } from "@material-tailwind/react";
import ClientReservationDetailedCard from "components/ClientReservationCard/ClientReservationDetailedCard";
import Heading2 from "components/Heading/Heading2";
import { AuthContext } from "context/appContext";
import { useAppDispatch, useAppSelector, useScrollToTop } from "hooks/hooks";
import { FC, useContext, useEffect, useState } from "react";
import { fetchReservationByClient } from "redux/features/reservations/reservationSlice";
import Pagination from "shared/Pagination/Pagination";
export interface SectionGridFilterCardProps {
  className?: string;
}

const ReservationGridDetailedCard: FC<SectionGridFilterCardProps> = ({ className = "" }) => {
  const authContext = useContext(AuthContext);
  const [loading, setIsLoading] = useState(false);
  const profilId = authContext?.user?.profil?.id;
  const dispatch = useAppDispatch();
  const reservationState = useAppSelector((state) => state.featureReservation.reservations);
  const totalPages = useAppSelector((state) => state.featureReservation.totalPages);
  const totalCount = useAppSelector((state) => state.featureReservation.totalCount);

  const [currentPage, setCurrentPage] = useState(1);
  useScrollToTop();
  useEffect(() => {
    if (profilId) {
      setIsLoading(true);
      dispatch(fetchReservationByClient({ id: profilId, page: currentPage })).then(() => setIsLoading(false));
    }
  }, [profilId, currentPage]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className={`nc-SectionGridFilterCard ${className}`} data-nc-id="SectionGridFilterCard">
      <Heading2
        heading="Mes événements"
        subHeading={<span className="block mt-3 text-neutral-500 dark:text-white">{totalCount} événements</span>}
      />

      <div className="grid grid-cols-1 gap-6 rounded-3xl">
        {loading ? (
          <div className="flex items-center justify-center mt-16 mb-2">
            <p>
              <Spinner color="blue" className="w-12 h-12" />
            </p>
          </div>
        ) : totalCount === 0 ? (
          <div className="flex items-center justify-center mt-16">
            <p>Pas de reservations disponibles</p>
          </div>
        ) : (
          reservationState.map((item, index) => (
            <ClientReservationDetailedCard defaultOpen={!index} key={index} data={item} />
          ))
        )}

        {totalPages > 1 && !loading && (
          <div className="flex items-center justify-center mb-2">
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReservationGridDetailedCard;
